module.exports = __webpack_public_path__ + "img/pfeffersal.d5492844.png";